module.exports = __webpack_public_path__ + "img/notebook.64d1ce7a.png";